import React, { useState, FC, useEffect } from "react";
import { Select } from "antd";
import { LabeledValue } from "antd/lib/select";
import { Api } from "../common/Api";
import { observer } from "mobx-react";

interface GooglePlacePickerProps {
  value?: LabeledValue;
  onChange?: (value: any) => void;
}

export const GooglePlacePicker: FC<GooglePlacePickerProps> = observer(({ value, onChange }) => {
  const [data, setData] = useState<any[]>(value ? [value] : []);
  const [keyword, setKeyword] = useState<LabeledValue | undefined>(value);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setData(value ? [value] : []);
    setKeyword(value);
  }, [value]);

  const handleSearch = (newValue: string) => {
    console.log("handleSearch", newValue);
    if (newValue) {
      setLoading(true);
      Api.utils.searchGooglePlaces(newValue).then((res) => {
        console.log(
          res.data,
          res.data.searchGooglePlaces.map(({ placeId: value, addr: label }) => ({ label, value }))
        );
        setData(res.data.searchGooglePlaces.map(({ placeId: value, addr: label }) => ({ label, value })));
        setLoading(false);
      });
    } else {
      setData([]);
    }
  };

  const handleChange = (newValue: LabeledValue) => {
    console.log("handleChange", newValue);
    setKeyword(newValue);
  };

  return (
    <Select
      showSearch
      value={keyword}
      placeholder="Input to search location"
      defaultActiveFirstOption={false}
      showArrow={false}
      labelInValue={true}
      filterOption={false}
      onSearch={handleSearch}
      onChange={handleChange}
      onSelect={(x) => onChange && onChange(x)}
      notFoundContent={null}
      options={data}
      loading={loading}
      allowClear
      onClear={() => onChange && onChange(null)}
    ></Select>
  );
});
